module.exports = __webpack_public_path__ + "static/media/img-reason-card-bg@3x.f089890e.png";